import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Button,
  TextField,
  Typography,
  Stack,
  Alert,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import axios from "axios";
import logo from "./logo_mobile_new-e1670105546624.png";
import sadImage from "./sad.png";
const judeteRomania = [
  "Alba",
  "Arad",
  "Argeș",
  "Bacău",
  "Bihor",
  "Bistrița-Năsăud",
  "Botoșani",
  "Brașov",
  "Brăila",
  "Buzău",
  "Caraș-Severin",
  "Călărași",
  "Cluj",
  "Constanța",
  "Covasna",
  "Dâmbovița",
  "Dolj",
  "Galați",
  "Giurgiu",
  "Gorj",
  "Harghita",
  "Hunedoara",
  "Ialomița",
  "Iași",
  "Ilfov",
  "Maramureș",
  "Mehedinți",
  "Mureș",
  "Neamț",
  "Olt",
  "Prahova",
  "Satu Mare",
  "Sălaj",
  "Sibiu",
  "Suceava",
  "Teleorman",
  "Timiș",
  "Tulcea",
  "Vâlcea",
  "Vaslui",
  "Vrancea",
  "București",
];

function CerereRestituit() {
  const [telefon, setTelefon] = useState("");
  const [email, setEmail] = useState("");
  const [rezultate, setRezultate] = useState([]);
  const [eroare, setEroare] = useState(false);
  const [selectate, setSelectate] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [adresa, setAdresa] = useState("");
  const [oras, setOras] = useState("");
  const [codPostal, setCodPostal] = useState("");
  const [nume, setNume] = useState("");
  const [judet, setJudet] = useState("");
  // Stare pentru animatia de succes la trimitere cerere
  const [cerereTrimisa, setCerereTrimisa] = useState(false);
  const [cerereFinalizata, setCerereFinalizata] = useState(false);
  const [issueId, setIssueId] = useState("");

  useEffect(() => {
    const header = document.getElementById("header");
    if (header) header.style.display = "none";

    return () => {
      if (header) header.style.display = "";
    };
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await axios.get(
        "https://server-9p4hx.kinsta.app/api/stocmanager/cerere-restituit/get",
        {
          params: { telefon, email },
        }
      );
      setRezultate(response.data);
      setEroare(response.data.length === 0);
      if (response.data.length > 0 && response.data[0].nume_si_prenume) {
        setNume(response.data[0].nume_si_prenume);
        console.log("Nume capturat:", response.data[0].nume_si_prenume);
      }
      if (response.data.length > 0 && response.data[0].issue_id) {
        setIssueId(response.data[0].issue_id);
      }
    } catch (err) {
      console.error("Eroare:", err);
      setRezultate([]);
      setEroare(true);
    }
  };

  // Funcție de toggle pentru selectarea cardurilor
  const toggleSelect = (idx) => {
    setSelectate((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  const isFormValid = telefon && email && adresa && oras && codPostal;

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        py: 6,
        background: "linear-gradient(180deg, #fafafa 0%, #efefef 100%)",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 6 }}>
        <img
          src={logo}
          alt="Logo Luxura"
          style={{ maxHeight: 38, objectFit: "contain", opacity: 0.85 }}
        />
      </Box>
      {!cerereFinalizata && (
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              color: "#111",
              letterSpacing: ".02em",
              mb: 1,
            }}
          >
            Cerere de restituire
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#6b6b6b",
              fontSize: "1.05rem",
              lineHeight: 1.7,
              maxWidth: 560,
              mx: "auto",
            }}
          >
            Te rugăm să selectezi articolele pe care dorești să le retragi din
            consignație.
          </Typography>
          <Box
            sx={{
              width: 64,
              height: 3,
              bgcolor: "#111",
              borderRadius: 2,
              mx: "auto",
              mt: 3,
            }}
          />
        </Box>
      )}

      {rezultate.length === 0 && (
        <Box
          sx={{
            bgcolor: "#0f0f0f",
            p: 4,
            borderRadius: 4,
            boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
            border: "1px solid #1f1f1f",
            backdropFilter: "blur(8px)",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            mt: 6,
          }}
        >
          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Nr. de telefon"
              variant="outlined"
              value={telefon}
              onChange={(e) => setTelefon(e.target.value)}
              InputLabelProps={{ style: { color: "#aaa" } }}
              inputProps={{ style: { color: "#fff" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  "& fieldset": { borderColor: "#3a3a3a" },
                  "&:hover fieldset": { borderColor: "#666" },
                  "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                },
              }}
            />
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputLabelProps={{ style: { color: "#aaa" } }}
              inputProps={{ style: { color: "#fff" } }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  "& fieldset": { borderColor: "#3a3a3a" },
                  "&:hover fieldset": { borderColor: "#666" },
                  "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                },
              }}
            />
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleSubmit}
              sx={{
                textTransform: "none",
                fontWeight: 700,
                py: 1.4,
                borderRadius: 2,
                background: "linear-gradient(90deg, #111 0%, #000 100%)",
                boxShadow: "0 12px 24px rgba(0,0,0,0.35)",
                color: "#fff",
                "&:hover": {
                  background: "linear-gradient(90deg, #000 0%, #111 100%)",
                },
              }}
            >
              Afișează
            </Button>
            {eroare && (
              <Alert severity="warning" sx={{ mt: 2, textAlign: "center" }}>
                Nu am găsit niciun rezultat pentru datele introduse.
              </Alert>
            )}
          </Stack>
        </Box>
      )}

      {rezultate.length > 0 && !showForm && !cerereFinalizata && (
        <Box mt={4}>
          <Typography variant="h6" color="#fff" gutterBottom>
            Rezultate găsite:
          </Typography>
          <Alert severity="info" variant="outlined" sx={{ mb: 2 }}>
            Selectează articolele pentru restituire atingând cardurile. Apoi
            apasă <strong>„Restituire”</strong>.
          </Alert>
          <Stack spacing={2}>
            {rezultate.map((item, idx) => {
              // Calculează diferența în milisecunde între azi și data de intrare
              const msDiff = new Date() - new Date(item.data_de_intrare);
              const isSub60zile = msDiff < 60 * 24 * 60 * 60 * 1000;
              const isSelectat = selectate.includes(idx);
              return (
                <Box
                  key={idx}
                  onClick={() => toggleSelect(idx)}
                  sx={{
                    p: 2.5,
                    borderRadius: 3,
                    bgcolor: isSelectat ? "#1c2530" : "#181818",
                    color: "#fff",
                    boxShadow: isSelectat
                      ? "0 16px 32px rgba(0,0,0,0.35)"
                      : "0 10px 24px rgba(0,0,0,0.25)",
                    cursor: "pointer",
                    border: "1px solid " + (isSelectat ? "#2e6ebd" : "#262626"),
                    transition:
                      "transform .15s ease, box-shadow .15s ease, border-color .15s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: "0 18px 36px rgba(0,0,0,0.35)",
                    },
                  }}
                >
                  <Typography variant="subtitle1" fontWeight={600}>
                    {item.summary}
                  </Typography>
                  <Typography variant="body2">
                    Tip achiziție: {item.tip_achizitie}
                  </Typography>
                  <Typography variant="body2">
                    Dată intrare:{" "}
                    {new Date(item.data_de_intrare).toLocaleDateString()}
                  </Typography>
                  {isSelectat && isSub60zile && (
                    <Alert severity="info" sx={{ mt: 2 }}>
                      Articolul se afla de mai puțin de 60 zile la Luxura
                      boutique și pentru retragere este necesară plata a 200
                      euro + TVA.
                    </Alert>
                  )}
                </Box>
              );
            })}
          </Stack>
          {selectate.length > 0 && !showForm && (
            <Box mt={3} textAlign="center">
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  background: "linear-gradient(90deg, #111 0%, #000 100%)",
                  color: "#fff",
                  width: "100%",
                  height: "60px",
                  borderRadius: 2,
                  boxShadow: "0 12px 24px rgba(0,0,0,0.35)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #000 0%, #111 100%)",
                  },
                }}
                onClick={() => setShowForm(true)}
              >
                Restituire
              </Button>
            </Box>
          )}
        </Box>
      )}

      {showForm && (
        <>
          <Box
            mt={4}
            sx={{
              bgcolor: "#0f0f0f",
              p: 4,
              borderRadius: 4,
              boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
              border: "1px solid #1f1f1f",
              color: "#fff",
              backdropFilter: "blur(8px)",
            }}
          >
            <Typography
              variant="body2"
              gutterBottom
              sx={{
                mb: 2,
                fontSize: "0.9rem",
                color: "#bbb",
                textAlign: "center",
              }}
            >
              Te rugăm să introduci adresa unde dorești să îți livrăm
              articolul/articolele.
            </Typography>
            <Stack spacing={2}>
              <input type="hidden" value={nume} readOnly />
              <TextField
                label="Adresă"
                variant="outlined"
                value={adresa}
                onChange={(e) => setAdresa(e.target.value)}
                InputLabelProps={{ style: { color: "#aaa" } }}
                inputProps={{ style: { color: "#fff" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    "& fieldset": { borderColor: "#3a3a3a" },
                    "&:hover fieldset": { borderColor: "#666" },
                    "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                  },
                }}
              />
              <TextField
                label="Oraș"
                variant="outlined"
                value={oras}
                onChange={(e) => setOras(e.target.value)}
                InputLabelProps={{ style: { color: "#aaa" } }}
                inputProps={{ style: { color: "#fff" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    "& fieldset": { borderColor: "#3a3a3a" },
                    "&:hover fieldset": { borderColor: "#666" },
                    "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                  },
                }}
              />
              <FormControl
                fullWidth
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    "& fieldset": { borderColor: "#3a3a3a" },
                    "&:hover fieldset": { borderColor: "#666" },
                    "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                  },
                }}
              >
                <InputLabel sx={{ color: "#ccc" }}>Județ</InputLabel>
                <Select
                  label="Județ"
                  value={judet}
                  onChange={(e) => setJudet(e.target.value)}
                  sx={{ color: "#fff" }}
                >
                  {judeteRomania.map((j) => (
                    <MenuItem key={j} value={j}>
                      {j}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Cod poștal"
                variant="outlined"
                value={codPostal}
                onChange={(e) => {
                  const onlyDigits = e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 6);
                  setCodPostal(onlyDigits);
                }}
                InputLabelProps={{ style: { color: "#aaa" } }}
                inputProps={{ style: { color: "#fff" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    "& fieldset": { borderColor: "#3a3a3a" },
                    "&:hover fieldset": { borderColor: "#666" },
                    "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                  },
                }}
              />
              <TextField
                label="Telefon"
                variant="outlined"
                value={telefon}
                onChange={(e) => setTelefon(e.target.value)}
                InputLabelProps={{ style: { color: "#aaa" } }}
                inputProps={{ style: { color: "#fff" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    "& fieldset": { borderColor: "#3a3a3a" },
                    "&:hover fieldset": { borderColor: "#666" },
                    "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                  },
                }}
              />
              <TextField
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputLabelProps={{ style: { color: "#aaa" } }}
                inputProps={{ style: { color: "#fff" } }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    "& fieldset": { borderColor: "#3a3a3a" },
                    "&:hover fieldset": { borderColor: "#666" },
                    "&.Mui-focused fieldset": { borderColor: "#9e9e9e" },
                  },
                }}
              />
            </Stack>
          </Box>
          <Box mt={2}>
            <Button
              variant="contained"
              sx={{
                textTransform: "none",
                fontWeight: 800,
                background: cerereTrimisa
                  ? "#2e7d32"
                  : "linear-gradient(90deg, #111 0%, #000 100%)",
                color: "#fff",
                width: "100%",
                height: "60px",
                borderRadius: 2,
                transition: "all 0.3s ease-in-out",
                boxShadow: cerereTrimisa
                  ? "0 12px 24px rgba(46,125,50,0.35)"
                  : "0 12px 24px rgba(0,0,0,0.35)",
                fontSize: cerereTrimisa ? "1.8rem" : "1rem",
                letterSpacing: cerereTrimisa ? "2px" : "normal",
                "&:hover": {
                  background: cerereTrimisa
                    ? "#2e7d32"
                    : "linear-gradient(90deg, #000 0%, #111 100%)",
                },
              }}
              disabled={!isFormValid}
              onClick={async () => {
                setCerereTrimisa(true);

                const produseSelectate = selectate.map((idx) => rezultate[idx]);

                try {
                  await axios.post(
                    "https://server-9p4hx.kinsta.app/api/stocmanager/cerere-restituit/submit",
                    {
                      email,
                      telefon,
                      nume_si_prenume: nume,
                      adresa,
                      oras,
                      judet,
                      cod_postal: codPostal,
                      produse: produseSelectate,
                    }
                  );
                } catch (err) {
                  console.error("Eroare la trimiterea cererii:", err);
                }

                setTimeout(() => {
                  setCerereTrimisa(false);
                  setShowForm(false);
                  setCerereFinalizata(true);
                }, 3000);
              }}
            >
              {cerereTrimisa ? (
                <span
                  style={{
                    display: "inline-block",
                    animation:
                      "bobo-success-pop 0.5s cubic-bezier(0.5,1.5,0.5,1.1)",
                  }}
                >
                  ✓
                </span>
              ) : (
                "Trimite cererea"
              )}
            </Button>
            <style>
              {`
              @keyframes bobo-success-pop {
                0% { transform: scale(0.5); opacity: 0; }
                60% { transform: scale(1.2); opacity: 1; }
                100% { transform: scale(1); opacity: 1; }
              }
            `}
            </style>
          </Box>
          <Box mt={2}>
            <Button
              variant="outlined"
              fullWidth
              sx={{
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                borderColor: "#555",
                color: "#555",
                "&:hover": { borderColor: "#000", color: "#000" },
              }}
              onClick={() => setShowForm(false)}
            >
              Înapoi
            </Button>
          </Box>
        </>
      )}

      {cerereFinalizata && (
        <Box mt={6} p={4} bgcolor="#f5f5f5" borderRadius={3} boxShadow={4}>
          <Typography
            variant="h5"
            fontWeight="bold"
            mb={2}
            color="#222"
            textAlign="center"
          >
            Cererea a fost trimisă cu succes{nume ? `, ${nume}` : ""}
          </Typography>
          <Box display="flex" justifyContent="center" mb={2}>
            <img src={sadImage} alt="Sad face" style={{ height: 60 }} />
          </Box>
          <Typography
            variant="body1"
            textAlign="center"
            color="#333"
            sx={{ fontSize: "1.05rem", lineHeight: 1.8, mb: 3 }}
          >
            Ne pare rău că dorești să retragi acest produs din Luxura Boutique.{" "}
            <br />
            Îți mulțumim pentru încrederea acordată și sperăm să revii în curând
            cu <strong style={{ color: "#000" }}>alte articole speciale</strong>
            .
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "3px",
              backgroundColor: "#000",
              margin: "0 auto 24px auto",
              borderRadius: "4px",
            }}
          />
          <Typography
            variant="body1"
            textAlign="center"
            color="#555"
            sx={{ fontSize: "1rem", lineHeight: 1.7 }}
          >
            Cererea ta a fost înregistrată și procesată cu succes. <br />
            În maximum <strong>72 de ore lucrătoare</strong>, produsul va fi
            expediat către tine.
          </Typography>
        </Box>
      )}
      <Box mt={8} textAlign="center">
        <Typography variant="body2" color="#aaa">
          Contact
        </Typography>
        <Typography variant="body2" color="#aaa" fontWeight={500}>
          037 44 14 660 &nbsp; • &nbsp; suport@luxuraelite.ro
        </Typography>
        <Typography variant="body2" color="#aaa">
          Luni–Vineri 10–20, Sâmbătă 10–18
        </Typography>
      </Box>
    </Container>
  );
}

export default CerereRestituit;
